<template>
    <Dialog :modal="true" v-model:visible="visible" header="Factura Electronica" :style="{ width: '28rem' }">
        <p class="tw-text-sm">Su factura sera enviada al siguiente correo electronico:</p>
        <InputText v-model="localEmail" class="tw-w-full tw-mt-2" placeholder="Email" />
        <template #footer>
            <Button label="Omitir" class="p-button-text" @click="visible = false" />
            <Button label="Enviar factura" :loading="sending" :disabled="!localEmail" @click="handleSend" />
        </template>
    </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import axios from '@/plugins/axios'

export default defineComponent({
    name: 'InvoiceEmailDialog',
    props: {
        modelValue: { type: Boolean, default: false },
        email: { type: String, default: '' },
        idFactura: { type: Number, default: null },
    },
    emits: ['update:modelValue', 'sent'],
    setup(props, { emit }) {
        const toast = useToast()
        const localEmail = ref(props.email)
        const sending = ref(false)

        const visible = computed({
            get: () => props.modelValue,
            set: (val: boolean) => emit('update:modelValue', val),
        })

        watch(() => props.email, (val) => { localEmail.value = val })

        const handleSend = async () => {
            if (!props.idFactura || !localEmail.value) return
            sending.value = true
            try {
                await axios.post('/turnos/send-invoice-email', {
                    idFactura: props.idFactura,
                    email: localEmail.value,
                })
                toast.add({ severity: 'success', summary: 'Factura enviada', detail: `Se envio al correo ${localEmail.value}`, life: 4000 })
                emit('sent')
                visible.value = false
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo enviar la factura. Intente nuevamente.', life: 4000 })
            } finally {
                sending.value = false
            }
        }

        return { visible, localEmail, sending, handleSend }
    },
})
</script>
